export class HrPaySstPercentageKey {
    private static readonly keyPrefix = 'hrPaySstPercentage';
    public static pageHeader = `${HrPaySstPercentageKey.keyPrefix}.pageHeader`;
    public static listHeader = `${HrPaySstPercentageKey.keyPrefix}.listHeader`;
    public static isEmployee = `${HrPaySstPercentageKey.keyPrefix}.isEmployee`;
    public static socialInsuranceBranch = `${HrPaySstPercentageKey.keyPrefix}.socialInsuranceBranch`;
    public static ssiDeclarationLaw = `${HrPaySstPercentageKey.keyPrefix}.ssiDeclarationLaw`;
    public static hazardousClass = `${HrPaySstPercentageKey.keyPrefix}.hazardousClass`;
    public static socialInsuranceDocumentType = `${HrPaySstPercentageKey.keyPrefix}.socialInsuranceDocumentType`;
    public static SSTInfo = `${HrPaySstPercentageKey.keyPrefix}.SSTInfo`;
    public static socialInsurancePercentage = `${HrPaySstPercentageKey.keyPrefix}.socialInsurancePercentage`;
}
